const DEFAULT_SEPARATOR = '-';

export const formatMarketRegion = (
  marketLocale: string,
  separator: string = DEFAULT_SEPARATOR
): string => {
  if (!marketLocale?.trim()) {
    return '';
  }

  const [language = '', region = ''] = marketLocale.split(separator);

  return `${language}${separator}${region.toUpperCase()}`;
};
